import { render, staticRenderFns } from "./saas-solutions.vue?vue&type=template&id=a44423b2&scoped=true&"
import script from "./saas-solutions.vue?vue&type=script&lang=js&"
export * from "./saas-solutions.vue?vue&type=script&lang=js&"
import style0 from "./saas-solutions.vue?vue&type=style&index=0&id=a44423b2&lang=scss&scoped=true&"
import style1 from "./saas-solutions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44423b2",
  null
  
)

export default component.exports